export * from './executor.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/executor.component/index.ts